function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M27.753 5.172H2.247C1.006 5.172 0 6.178 0 7.419V22.581c0 1.241 1.006 2.247 2.247 2.247h25.506c1.241 0 2.247 -1.006 2.247 -2.247V7.419C30 6.178 28.994 5.172 27.753 5.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M29.969 7.048c-0.177 -1.064 -1.101 -1.875 -2.216 -1.875h-0.585l-9.582 6.278V5.172h-5.172v6.278L2.831 5.172h-0.585c-1.114 0 -2.039 0.811 -2.216 1.875l8.19 5.366H0v5.172h8.221L0.031 22.952c0.177 1.064 1.101 1.875 2.216 1.875h0.585l9.582 -6.278v6.278h5.172V18.549l9.582 6.278h0.585c1.114 0 2.039 -0.811 2.216 -1.875l-8.19 -5.366H30v-5.172H21.779L29.969 7.048z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    points: "282.483,88.276 229.517,88.276 229.517,229.517 0,229.517 0,282.483 229.517,282.483  229.517,423.724 282.483,423.724 282.483,282.483 512,282.483 512,229.517 282.483,229.517  ",
    d: "M16.552 5.172L13.448 5.172L13.448 13.448L0 13.448L0 16.552L13.448 16.552L13.448 24.828L16.552 24.828L16.552 16.552L30 16.552L30 13.448L16.552 13.448Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M1.453 24.683l10.933 -7.097h-1.9L0.54 24.042C0.784 24.326 1.097 24.548 1.453 24.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M20.296 17.586H18.396l10.589 6.873c0.296 -0.195 0.544 -0.457 0.72 -0.766L20.296 17.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0.237 6.415l9.242 5.999h1.9L0.907 5.616C0.626 5.825 0.395 6.099 0.237 6.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M19.486 12.414l9.963 -6.467c-0.246 -0.283 -0.561 -0.504 -0.92 -0.636L17.586 12.414H19.486z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/UK.bfb5943295f6a96199d9deae85df1822.svg";
export { ForwardRef as ReactComponent };